import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Grid,
  Modal,
  Input,
} from '../../components/index';

import User from '../../domain/User';

import {
  tamanhoMaximoArquivoUpload,
} from '../../utils/constants';
import UploadDragDrop from '../../components/ComponentesBasicos/UploadDragDrop';

class ModalUploadDocumento extends Component {
  constructor() {
    super();

    this.state = {
      documents: [],
      tipoDocumento: null,
      tiposDisponiveis: [],
      nomeDependente: null,
      exibirNomeDependente: false,
    };
  }

  componentDidMount() {
    this.montaListaDocumentosDisponiveis();
  }

  isConsultaExigencia = () => (
    this.props.acao === 'consulta'
    && this.props.requerimento.estado === 2
  )

  montarListaDocumentosAdicionais = (paramLista) => {
    let lista = paramLista;

    const tiposDocumentos =
      this.props.tiposDocumentos || [];

    const inss = '01000';

    const destinatarioOuSolicitanteRGPS =
      User.logged().isRGPS()
      || this.props.requerimento.destinatario === inss;

    const acordos =
      destinatarioOuSolicitanteRGPS
        ? [1, 3]
        : [2, 3];

    const regimes =
      User.logged().isRGPS()
        ? [1, 3]
        : [2, 3];

    lista = tiposDocumentos.filter(doc => doc.value !== 19 && doc.value !== 20 && doc.categoria === 1);

    lista = lista.filter(doc => (doc.abrangenciaAplicavel === this.props.tipoRequerimento || doc.abrangenciaAplicavel == null)
      && acordos.includes(doc.acordoAplicavel)
      && regimes.includes(doc.regimeAplicavel));

    return lista;
  }

  montaListaDocumentosDisponiveis = () => {
    let lista = [];

    if (this.isConsultaExigencia()) {
      if (this.props.possuiExigenciaDocumento) {
        if (
          this.props.requerimento
          && this.props.listaExigencias
        ) {
          this.props.listaExigencias.forEach((exigencia) => {
            if (
              exigencia.tipoDocumento
              && !exigencia.atributo
            ) {
              let acaoFormatada = exigencia.acao;

              if (
                exigencia.tipoDocumento === 13
                && exigencia.comentario
              ) {
                acaoFormatada =
                  `${exigencia.acao} - ${exigencia.comentario}`;
              }

              lista.push({
                value:
                  exigencia.codigoDependente
                    ? `${exigencia.tipoDocumento}${exigencia.codigoDependente}`
                    : exigencia.tipoDocumento,

                label: acaoFormatada,

                dependente:
                  exigencia.codigoDependente,
              });
            }
          });
        }
      } else {
        lista = this.montarListaDocumentosAdicionais(lista);
      }
    } else {
      lista = this.montarListaDocumentosAdicionais(lista);
    }

    this.setState({
      tiposDisponiveis: lista,
    });
  }

  handleChangeExigencia = (changeObj, name) => {
    let paramExibirNomeDependente = false;

    const listaDependentes =
      this.props.requerimento.dependentes;

    const listaExigencias =
      this.props.requerimento.exigencias;

    let paramNomeDependente = '';
    let dependente = '';
    let valor = '';
    let codigoDependente = '';

    if (
      listaExigencias
      && listaExigencias.length > 0
    ) {
      for (
        let i = 0;
        i < listaExigencias.length;
        i += 1
      ) {
        const exigencia = listaExigencias[i];

        if (
          exigencia.tipoDocumento
          && exigencia.codigoDependente
        ) {
          valor =
            `${exigencia.tipoDocumento}${exigencia.codigoDependente}`;

          if (Number(valor) === changeObj.value) {
            dependente = valor.match(exigencia.codigoDependente);
            break;
          }
        }
      }

      if (dependente !== '') {
        codigoDependente = Number(dependente[0]);

        const indexDep = listaDependentes.findIndex(depDisp => depDisp.codigo === codigoDependente);

        paramNomeDependente =
          listaDependentes[indexDep].nome;

        if (paramNomeDependente !== '') {
          paramExibirNomeDependente = true;
        }

        this.setState({
          nomeDependente:
            paramNomeDependente,

          exibirNomeDependente:
            paramExibirNomeDependente,
        });
      }
    }

    if (changeObj.value === '') {
      this.setState({
        nomeDependente: '',
        exibirNomeDependente: false,
      });
    }

    this.setState({
      [name]: changeObj.value,
    });
  }

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    });
  }

  checkIfFileCanBeSent = () => (
    this.state.documents.length > 0
    && this.state.tipoDocumento
  )

  addArquivo = () => {
    const { documents } = this.state;

    if (!documents || documents.length === 0) {
      return;
    }

    const arquivosAdicionados = [];

    documents.forEach((documentoAtual) => {
      let arquivo = {};

      if (this.isConsultaExigencia()) {
        const tamanhoDocumentoUpload =
          documentoAtual.size;

        let tipoDoc = '';
        let valor = '';

        let nomeDependenteExigencia = '';
        let codigoDependenteExigencia = '';

        if (
          tamanhoDocumentoUpload
          < tamanhoMaximoArquivoUpload
        ) {
          const listaExigencias =
            this.props.requerimento.exigencias;

          const listaDependentes =
            this.props.requerimento.dependentes;

          if (
            listaDependentes
            && listaDependentes.length > 0
          ) {
            for (let i = 0; i < listaExigencias.length; i += 1) {
              const exigencia = listaExigencias[i];
              if (
                exigencia.tipoDocumento
                && exigencia.codigoDependente
              ) {
                valor =
                  `${exigencia.tipoDocumento}${exigencia.codigoDependente}`;

                if (
                  Number(valor)
                  === this.state.tipoDocumento
                ) {
                  tipoDoc = valor.match(exigencia.tipoDocumento);
                  tipoDoc = Number(tipoDoc[0]);
                  codigoDependenteExigencia = exigencia.codigoDependente;
                  break;
                }
              } else if (
                exigencia.tipoDocumento
                && !exigencia.codigoDependente
              ) {
                tipoDoc =
                  exigencia.tipoDocumento;

                break;
              } else if (
                !exigencia.tipoDocumento
                && !exigencia.codigoDependente
              ) {
                tipoDoc =
                  this.state.tipoDocumento;

                break;
              }
            }

            if (
              codigoDependenteExigencia
              && codigoDependenteExigencia !== ''
            ) {
              const indexDep = listaDependentes.findIndex(exi => exi.codigo === codigoDependenteExigencia);
              nomeDependenteExigencia = listaDependentes[indexDep].nome;
            }

            arquivo = {
              documento: documentoAtual,
              tipoDocumento: tipoDoc,
              nomeDependente: nomeDependenteExigencia,
              codigoDependente: codigoDependenteExigencia,
            };

            const indexExigencia = this.props.listaExigencias.findIndex(exi => exi.tipoDocumento === tipoDoc && exi.codigoDependente === codigoDependenteExigencia);

            if (indexExigencia !== -1) {
              this.props.listaExigencias.splice(indexExigencia, 1);
            }
          } else {
            const indexExigencia =
              this.props.listaExigencias.findIndex(exi => exi.tipoDocumento === this.state.tipoDocumento);

            if (indexExigencia !== -1) {
              this.props.listaExigencias.splice(
                indexExigencia,
                1,
              );
            }

            arquivo = {
              documento: documentoAtual,
              tipoDocumento:
                this.state.tipoDocumento,
            };
          }
        } else {
          arquivo = {
            documento: documentoAtual,
            tipoDocumento:
              this.state.tipoDocumento,
          };
        }
      } else {
        arquivo = {
          documento: documentoAtual,
          tipoDocumento:
            this.state.tipoDocumento,
        };
      }

      arquivosAdicionados.push(arquivo);
    });

    this.props.addArquivo(
      arquivosAdicionados,
      this.props.arquivo,
    );
  }

  handleDocumentSent = (response) => {
    const tipoDocumentoCarregado =
      this.state.tipoDocumento;

    this.setState(
      {
        documents: [],
        tipoDocumento: null,
        tiposDisponiveis: [],
      },
      () => this.props.handleDocumentSent(
        response.headers.location,
        tipoDocumentoCarregado,
      ),
    );
  }

  handleClose = () => {
    this.setState(
      {
        documents: [],
      },
      this.props.handleModal('showDocumentUploadModal'),
    );
  }

  exibirModalConsultaExigencia = () => {
    let retorno = false;

    if (this.isConsultaExigencia()) {
      retorno = true;
    }

    return retorno;
  }

  modalDocumentUploadContent = () => (
    <React.Fragment>
      <div className="row">
        <Grid cols="8 8 12 12">
          <Input
            label="Tipo de documento"
            number
            placeholder="Selecione o tipo de documento"
            onChange={e =>
              this.handleChange(
                e,
                'tipoDocumento',
              )}
            value={this.state.tipoDocumento}
            itemList={
              this.state.tiposDisponiveis
            }
            required
            custom
          />
        </Grid>
      </div>
      <UploadDragDrop
        files={this.state.documents}
        onChange={documents => this.setState({ documents })}
        multiple={false}
        accept="application/pdf,.pdf"
        minHeight={70}
        titulo="Arraste o arquivo PDF aqui"
        subtitulo="ou clique para selecionar"
      />
    </React.Fragment>
  )

  modalExigenciaUploadContent = () => (
    <React.Fragment>
      {this.state.exibirNomeDependente ? (
        <div className="row">
          <Grid cols="8 8 12 12">
            <Input
              label="Dependente"
              value={this.state.nomeDependente}
              disabled
            />
          </Grid>
        </div>
      ) : ''}

      <div className="row">
        <Grid cols="8 8 12 12">
          <Input
            label="Tipo de documento"
            number
            placeholder="Selecione o tipo de documento"
            onChange={e =>
              this.handleChangeExigencia(
                e,
                'tipoDocumento',
              )}
            value={this.state.tipoDocumento}
            itemList={
              this.state.tiposDisponiveis
            }
            required
            custom
          />
        </Grid>
      </div>
      <UploadDragDrop
        files={this.state.documents}
        onChange={documents => this.setState({ documents })}
        multiple={false}
        accept="application/pdf,.pdf"
        minHeight={70}
        titulo="Arraste o arquivo PDF aqui"
        subtitulo="ou clique para selecionar"
      />
    </React.Fragment>
  )

  modalDocumentUploadFooter = () => (
    <React.Fragment>
      <div className="right">
        <Button
          className="dtp-primary"
          disabled={
            !this.checkIfFileCanBeSent()
          }
          hint="Anexar documento"
          onClick={this.addArquivo}
          title="Anexar"
        />
      </div>
    </React.Fragment>
  )

  render() {
    return (
      <Modal
        {...this.props}
        conteudofooter={
          this.modalDocumentUploadFooter()
        }
        conteudomodal={
          this.exibirModalConsultaExigencia()
            ? this.modalExigenciaUploadContent()
            : this.modalDocumentUploadContent()
        }
        onHide={this.handleClose}
        size="md"
        showModal={this.props.showModal}
        title="Incluir documento ao requerimento"
      />
    );
  }
}

ModalUploadDocumento.propTypes = {
  addArquivo: PropTypes.func.isRequired,
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
  handleDocumentSent: PropTypes.func,
}.isRequired;

export default ModalUploadDocumento;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/ModalUploadArquivos.jsx